
import { TestTypes } from "@Constants/app.constant";
import InstructionSvg from "@Assets/svg/Dashboard-svgs/instruction.svg";
import "../Test-question-card/Test-question-card.scss";
import SvgIcon from '@Components/icons/SvgIcon';
import { getUserDeviceDetails } from "@Src/utils/service/device-details.service";

export const QuestionpaperrightFooter = ({ testType, fullQuestionPaperMode, instruction, setFullQuestionPaperModeHandler, setinstructionHadndler, onClickEndTestHandler, isLoading }: any) => {
  const onClickQuestionPalette = () => {
    setinstructionHadndler(false);
    setFullQuestionPaperModeHandler(false);
    if (fullQuestionPaperMode == true) {
      setFullQuestionPaperModeHandler(false);
    } else if (fullQuestionPaperMode == false) {
      setFullQuestionPaperModeHandler(true);
    }
  }
  const onClickInstruction = () => {
    if (instruction == true) {
      setinstructionHadndler(false);
      setFullQuestionPaperModeHandler(false);
    } else if (instruction == false) {
      setinstructionHadndler(true);
      setFullQuestionPaperModeHandler(false);
    }
  }

  if (isLoading) {
    return (
      <div className="footer-right-card">
        <div className="qust-inst-card tw-justify-between">
          <div className="tw-animate-pulse tw-h-11 tw-w-32 tw-bg-gray-200 tw-rounded-lg"></div>
          <div className="tw-animate-pulse tw-h-11 tw-w-32 tw-bg-gray-200 tw-rounded-lg"></div>
        </div>
        <div className="tw-w-full tw-mt-3">
          <div className="tw-animate-pulse tw-h-12 tw-w-full tw-bg-gray-200 tw-rounded-lg"></div>
        </div>
      </div>
    )
  }

  return (
    <>

      <div className="footer-right-card">
        <div className="qust-inst-card tw-justify-between">
          {testType == TestTypes.regular ? <a
            href="javascript:void(0)"
            className={`qust-a-btn  ${fullQuestionPaperMode ? 'active-btn' : null}`}
            onClick={() => {
              onClickQuestionPalette()
            }
            }
          >
            {
              !(getUserDeviceDetails().device === "DESKTOP") ? <span className="tw-text-sm">
                Question Paper
              </span> : <span className="tw-text-sm">
                {fullQuestionPaperMode ? 'Question Palette' : 'Question Paper'}
              </span>
            }
            {/* <span className="tw-text-sm">
                {fullQuestionPaperMode ? 'Question Palette' : 'Question Paper'}
               </span> */}
          </a> : ''}
          <a
            href="javascript:void(0)"
            className={`qust-inst-btn speed-test-inst px-2 py-2 flex-inline tw-items-center gap-2  ${instruction ? 'active-btn' : null}`}
            onClick={() => {
              onClickInstruction()
            }}
          >
            <SvgIcon name="mockTest" size={22} /> <span className="tw-text-sm">Instructions</span>
          </a>
        </div>

        <div className="tw-w-full" onClick={() => onClickEndTestHandler()} >
          <a href="javascript:void(0)" className="end-test-btn1 ia-btn ia-btn-primary w-full tw-justify-center mt-3">
            <span className="tw-text-lg">End Test</span>
          </a>
        </div>
      </div>

    </>
  )
}